<template>
  <v-container fluid>
    <v-card>
      <v-toolbar>
            <v-toolbar-title>Filter Courses</v-toolbar-title>
            <v-spacer/>
            <v-text-field
            v-model="search"
            clearable
            flat
            solo-inverted
            hide-details
            prepend-inner-icon="mdi-magnify"
            label="Search a course or teacher"
          ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn icon @click="filter = !filter">
              <v-icon>mdi-filter-outline</v-icon>
            </v-btn>
        </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" lg="4">
        <v-select
              v-model="subject_selected"
              hide-details
              :items="subjects"
              label="Select Subject"
              value:selected
              return-object
              search-input
              filled
              chips
              dense
              class="ml-5 mt-0"
            ></v-select>
          </v-col>
          <v-col>
            <v-select
              :items="days_of_week"
              filled
              label="Select Days of the Week"
              dense
              multiple
              chip
            ></v-select>
          </v-col>
          <v-col cols="12" lg="4">
             <v-checkbox
              v-model="select_1on1"
              label="Individual Class "
              value="true"
              min-width="150px"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
      <open-courses />
  </v-container>
</template>

<script>
import { courses, teachers } from "../../data/courses_teachers";
import OpenCourses from "@/components/course/OpenCourses.vue"

export default {
  data() {
    return {
      search: "",
      filter: {},
      sortDesc: false,
      sortBy: "title",
      keys: [
        "Title",
        "Price",
        // "Reviews",
        // "Rating",
        "Size",
      ],
      subjects: ["Math", "ELA"],
      subject_selected: [],

      arrayEvents: null,

      start_date: new Date().toISOString().substr(0, 10),
      end_date: new Date().toISOString().substr(0, 10),

      menu: false,

      days_of_week: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      starting_hours: [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
      courses: courses,
      teachers: teachers,
      select_1on1:false
    };
  },
  components: {
    OpenCourses
  },
  mounted() {
    this.arrayEvents = [...Array(6)].map(() => {
      const day = Math.floor(Math.random() * 30);
      const d = new Date();
      d.setDate(day);
      return d.toISOString().substr(0, 10);
    });
  },

  methods: {
    functionEvents(date) {
      const [, , day] = date.split("-");
      if ([12, 17, 28].includes(parseInt(day, 10))) return true;
      if ([1, 19, 22].includes(parseInt(day, 10))) return ["red", "#00f"];
      return false;
    },
  },
};
</script>

<style scoped></style>
